import { EnvironmentInfo } from "core";

// Environment di pre-produzione.
// Usare flag "--configuration=preq8".
// es. "ng serve --configuration=preq8" o "ng build q8oils --configuration=preq8".
export const environment: EnvironmentInfo = {
    baseApiUrl: 'https://ain-test.ciam.q8.com/businessapp_api',
    clientId: 'client_id',
    clientSecret: 'client_secret',
    ciamClientId: 'l301s7obVzqJuKI4epxQQC5PPCQa',
    ciamBaseUrl: 'https://ais-test.ciam.q8.com/ciamauthentication',
    ciamScope: 'openid internal_org_user_mgt_view internal_org_user_mgt_list internal_org_user_mgt_create nternal_org_user_mgt_update internal_org_user_mgt_delete internal_user_mgt_view internal_user_mgt_list internal_user_mgt_create internal_user_mgt_update internal_user_mgt_delete',
    
    // TODO: l'header non va hardcodato nel codice, viene consigliato di riceverlo da una chiamata backend apposita
    ciamTokenAuthHeader: 'Basic bDMwMXM3b2JWenFKdUtJNGVweFFRQzVQUENRYTphWUJLZk4xRzVIQUpmZWx6WXFKM1gycnF4bkZaM2FlVVNqWHhzVHZqbm1VYQ==',
    
    mapsApiKey: 'AIzaSyAml6bLEXdE7EYC0KAbpm5c_S31tQCNeFM'
};

